// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Pervasives from "../../../../../../node_modules/rescript/lib/es6/pervasives.js";
import * as ReactModal from "react-modal";
import * as CountryContext from "../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as ModalStyles$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/modal/ModalStyles.bs.js";
import * as BulkUploadRepoManager from "../../app/bulk-upload/repo/BulkUploadRepoManager.bs.js";
import * as FormTitleBar$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormTitleBar.bs.js";
import * as SuccessInfoComponent$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/custom/success/SuccessInfoComponent.bs.js";
import * as BulkUploadTransactionsModalContent from "../../BulkUploadTransactionsModalContent.bs.js";
import * as FixedLoadingViewComponent$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/FixedLoadingViewComponent.bs.js";

function mapFormStateToRepoRequest(formState) {
  var match = formState.fileUploadResult;
  var match$1;
  if (match !== undefined) {
    var result = match[0];
    match$1 = result.TAG === /* Ok */0 ? [
        result._0,
        match[1]
      ] : Pervasives.failwith("CSV errors at bulkupload form");
  } else {
    match$1 = Pervasives.failwith("CSV not uploaded");
  }
  var cityName = formState.city;
  var reason = formState.reason;
  return {
          city: cityName !== undefined ? cityName : Pervasives.failwith("City not set in bulk upload form"),
          reason: reason !== undefined ? reason.value : Pervasives.failwith("reason not set in bulk upload form"),
          partner_requests: match$1[0],
          file_name: match$1[1]
        };
}

function BulkUploadTransactionsModal(Props) {
  var closeCreateTransactionModal = Props.closeCreateTransactionModal;
  var match = React.useState(function () {
        return /* Init */0;
      });
  var setRequestStatus = match[1];
  var requestStatus = match[0];
  var match$1 = CountryContext.useContext(undefined);
  var country = match$1.country;
  var bulkUploadTransactions = function (request, onSubmitCallback) {
    var Repo = BulkUploadRepoManager.getRepo(undefined);
    return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                  return Curry._2(Repo.bulkUpload, mapFormStateToRepoRequest(request), country);
                }), (function (data) {
                  Curry._1(setRequestStatus, (function (param) {
                          return {
                                  TAG: /* Live */1,
                                  _0: data
                                };
                        }));
                  return Curry._1(onSubmitCallback, undefined);
                }), (function (_message) {
                  return Curry._1(onSubmitCallback, undefined);
                }));
  };
  var resetRequestStatus = function (param) {
    return Curry._1(setRequestStatus, (function (param) {
                  return /* Init */0;
                }));
  };
  var tmp;
  var exit = 0;
  if (typeof requestStatus === "number") {
    exit = 1;
  } else {
    switch (requestStatus.TAG | 0) {
      case /* Loading */0 :
          tmp = React.createElement(React.Fragment, undefined, React.createElement(FixedLoadingViewComponent$Catalyst.make, {}), React.createElement(BulkUploadTransactionsModalContent.make, {
                    bulkUploadTransactions: bulkUploadTransactions,
                    requestStatus: requestStatus,
                    resetRequestStatus: resetRequestStatus
                  }));
          break;
      case /* Live */1 :
          tmp = requestStatus._0.TAG === /* Ok */0 ? React.createElement(SuccessInfoComponent$Catalyst.make, {
                  message: "Successfully uploaded wallet requests"
                }) : React.createElement(BulkUploadTransactionsModalContent.make, {
                  bulkUploadTransactions: bulkUploadTransactions,
                  requestStatus: requestStatus,
                  resetRequestStatus: resetRequestStatus
                });
          break;
      case /* Error */2 :
          exit = 1;
          break;
      
    }
  }
  if (exit === 1) {
    tmp = React.createElement(BulkUploadTransactionsModalContent.make, {
          bulkUploadTransactions: bulkUploadTransactions,
          requestStatus: requestStatus,
          resetRequestStatus: resetRequestStatus
        });
  }
  return React.createElement(ReactModal, {
              isOpen: true,
              onRequestClose: (function (param) {
                  return Curry._1(closeCreateTransactionModal, undefined);
                }),
              style: ModalStyles$Catalyst.getAlignContentCenterStyle(undefined, undefined),
              shouldCloseOnOverlayClick: false,
              children: React.createElement("div", {
                    className: "porter-form u-scrollable-y u-form-full-height"
                  }, React.createElement(FormTitleBar$Catalyst.make, {
                        title: "Bulk upload Wallet Transactions",
                        onCloseCb: (function (param) {
                            return Curry._1(closeCreateTransactionModal, undefined);
                          })
                      }), tmp)
            });
}

var make = BulkUploadTransactionsModal;

export {
  mapFormStateToRepoRequest ,
  make ,
  
}
/* react Not a pure module */
